import { makeStyles } from "tss-react/mui";
import { palette, radius } from "@/themes/tokens";

// Contact card as on mobile: photo, name, round brand-colour call/email buttons.
export const useLotContactListStyles = makeStyles()((theme) => ({
    container: { minHeight: 80 },
    imageContainer: { width: 100, minWidth: 100, height: 100, padding: 12, paddingRight: 0, boxSizing: "content-box" },
    infoContainer: { padding: 12, minWidth: 0, flex: 1 },
    image: { width: "100%", height: "100%", borderRadius: radius.md },
    contactHeading: { marginBottom: 8, color: palette.text, fontSize: 16, fontWeight: 700 },
    contactButtonsContainer: { marginTop: 8, gap: 6 },
    link: { marginRight: 25, marginTop: 4, textDecoration: "none" },
    buttonIcon: {
        width: 36,
        height: 36,
        padding: 8,
        borderRadius: "50%",
        color: "white",
        background: "#ff0000"
    },
    buttonLabel: { color: palette.textMuted, fontSize: 13 },
}));
